import { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const reviews = [
  {
    name: 'James W.',
    location: 'Wellesley, MA',
    rating: 5,
    date: 'March 2024',
    service: 'Custom Suit',
    text: 'Absolutely outstanding experience from start to finish. My wedding suit fit like a glove and I received compliments all night. The team was patient, knowledgeable, and genuinely passionate about their craft. I will never buy off-the-rack again.',
    avatar: 'JW',
  },
  {
    name: 'Robert C.',
    location: 'Newton, MA',
    rating: 5,
    date: 'February 2024',
    service: 'Custom Shirts',
    text: 'I ordered six custom shirts for work and the quality is exceptional. The fit is perfect — something I have never achieved with store-bought shirts. The house call service was incredibly convenient. Highly recommend.',
    avatar: 'RC',
  },
  {
    name: 'Michael T.',
    location: 'Brookline, MA',
    rating: 5,
    date: 'January 2024',
    service: 'Alterations',
    text: 'Brought in a designer suit that needed significant alterations. The result was flawless — it looks like it was made for me. The turnaround was fast and the price was very fair. This is my go-to tailor from now on.',
    avatar: 'MT',
  },
  {
    name: 'David H.',
    location: 'Weston, MA',
    rating: 5,
    date: 'December 2023',
    service: 'Custom Blazer',
    text: 'Had a custom blazer made for a board presentation. The fabric selection was incredible and the clothier helped me choose something that was both professional and distinctive. Received so many compliments. Worth every penny.',
    avatar: 'DH',
  },
  {
    name: 'Andrew P.',
    location: 'Needham, MA',
    rating: 5,
    date: 'November 2023',
    service: 'Custom Suit',
    text: 'Custom Clothiers made my first bespoke suit and I am completely hooked. The process was enjoyable, the staff was warm and professional, and the final product exceeded my expectations. Already planning my next order.',
    avatar: 'AP',
  },
  {
    name: 'Thomas G.',
    location: 'Natick, MA',
    rating: 5,
    date: 'October 2023',
    service: 'Custom Shirts',
    text: 'The quality of the shirts is remarkable. Egyptian cotton, perfect collar fit, and the monogram detail was a lovely touch. The team took the time to understand exactly what I wanted. Exceptional service.',
    avatar: 'TG',
  },
  {
    name: 'William O.',
    location: 'Dedham, MA',
    rating: 5,
    date: 'September 2023',
    service: 'Alterations',
    text: 'Needed a rush alteration on a suit before a big event. They accommodated me on short notice and the work was impeccable. The staff was friendly and professional throughout. Cannot recommend them enough.',
    avatar: 'WO',
  },
  {
    name: 'Christopher L.',
    location: 'Boston, MA',
    rating: 5,
    date: 'August 2023',
    service: 'Custom Suit',
    text: 'I have been a client for over five years and the consistency of quality and service is remarkable. Every suit is better than the last. Custom Clothiers is simply the best tailor in the Massachusetts area.',
    avatar: 'CL',
  },
  {
    name: 'Samuel B.',
    location: 'Framingham, MA',
    rating: 5,
    date: 'July 2023',
    service: 'Custom Blazer',
    text: 'The house call service was a game changer for me. They came to my office, took measurements, helped me choose a fabric, and delivered a stunning blazer in 6-8 weeks. Seamless and professional.',
    avatar: 'SB',
  },
];

const stats = [
  { value: '4.9', label: 'Average Rating', icon: 'ri-star-fill' },
  { value: '127+', label: 'Reviews', icon: 'ri-chat-3-line' },
  { value: '55+', label: 'Years Serving Massachusetts', icon: 'ri-award-line' },
  { value: '3500+', label: 'Happy Clients', icon: 'ri-user-smile-line' },
];

const ReviewsPage = () => {
  const [filter, setFilter] = useState<string>('All');
  const services = ['All', 'Custom Suit', 'Custom Shirts', 'Custom Blazer', 'Alterations'];

  const filtered = filter === 'All' ? reviews : reviews.filter((r) => r.service === filter);

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero */}
      <section className="bg-gradient-to-br from-gray-900 to-gray-800 text-white pt-32 pb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-[#C4A962] font-semibold tracking-widest uppercase text-sm mb-4">Client Reviews</p>
          <h1 className="text-5xl md:text-6xl font-bold mb-6">What Our Clients Say</h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Over 200 five-star reviews from clients across Greater Boston. See why Custom Clothiers is the region's most trusted tailor.
          </p>
        </div>
      </section>

      {/* Stats */}
      <section className="bg-[#C4A962] py-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {stats.map((s) => (
              <div key={s.label} className="text-center">
                <div className="w-10 h-10 flex items-center justify-center mx-auto mb-2">
                  <i className={`${s.icon} text-white text-2xl`}></i>
                </div>
                <p className="text-3xl font-bold text-white">{s.value}</p>
                <p className="text-white/80 text-sm mt-1">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Filter */}
      <section className="py-10 bg-gray-50 border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap gap-3 justify-center">
            {services.map((s) => (
              <button
                key={s}
                onClick={() => setFilter(s)}
                className={`px-5 py-2 rounded-full text-sm font-semibold transition-colors whitespace-nowrap ${
                  filter === s
                    ? 'bg-[#C4A962] text-white'
                    : 'bg-white text-gray-600 border border-gray-200 hover:border-[#C4A962] hover:text-[#C4A962]'
                }`}
              >
                {s}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Reviews Grid */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filtered.map((review) => (
              <div key={review.name} className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 hover:shadow-md transition-shadow flex flex-col">
                <div className="flex items-center gap-1 mb-4">
                  {Array.from({ length: review.rating }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-[#C4A962] text-lg"></i>
                  ))}
                </div>
                <p className="text-gray-600 text-sm leading-relaxed flex-1 mb-6">"{review.text}"</p>
                <div className="flex items-center gap-4 pt-4 border-t border-gray-100">
                  <div className="w-11 h-11 rounded-full bg-[#C4A962] flex items-center justify-center flex-shrink-0">
                    <span className="text-white font-bold text-sm">{review.avatar}</span>
                  </div>
                  <div>
                    <p className="font-bold text-gray-900 text-sm">{review.name}</p>
                    <p className="text-gray-400 text-xs">{review.location} · {review.date}</p>
                  </div>
                  <span className="ml-auto text-xs font-medium text-[#C4A962] bg-[#C4A962]/10 px-3 py-1 rounded-full whitespace-nowrap">
                    {review.service}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-gray-900 text-white">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold mb-4">Ready to Experience the Difference?</h2>
          <p className="text-gray-400 text-lg mb-8">Join hundreds of satisfied clients across Greater Boston. Book your complimentary consultation today.</p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/contact" className="bg-[#C4A962] text-white px-8 py-4 rounded-lg font-bold hover:bg-[#B39952] transition-colors whitespace-nowrap">
              Book a Free Consultation
            </Link>
            <a href="tel:781-237-3166" className="border-2 border-white text-white px-8 py-4 rounded-lg font-bold hover:bg-white/10 transition-colors whitespace-nowrap">
              Call 781-237-3166
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ReviewsPage;
